/* global MI, FreeSpinOption, Promise */

import {MI} from "../init";
import Shuffling from "../Shuffling";
import SymbolsManager from "../symbol/SymbolsManager";
import FreeSpinOption from "../game/FreeSpinOption";
import {madnes_get_json} from "../../framework/src/engine/madnes/madnes";

/**
 * @constructor
 * @returns {Game}
 */
export default function Preinfo() {

    this._fadeIn = 300;
    this._fadeOut = 300;

    this._activeSlides = {
        "expand": false,
        "rappear": false,
        "shuffling": false,
        "changing": false,
        "freespins": false
    };

    /** @type {GameAssets} */
    this._assets;

    this._onClose = function() {};

    this._autorunFuncs = [];
    this._autorunIdx = 0;
    /** @type {MadnesTimer} */
    this._autorunInterval;
    /** @type {MadnesTimer} */
    this._autorunDelay;

    /** @type {MadnesObject} */
    this._bg;

    /** @type Shuffling */
    this._shuffling = new Shuffling();
    this._shuffling.setMinSteps(2);

    this._scaleSymb = 0.6;

    /** @type {Array<MadnesObject>} */
    this.buttonsActive = [];
    /** @type {Array<MadnesObject>} */
    this.buttons = [];

    /** @type {Array<MadnesTimer>} */
    this._blinkTimers = [];

    /** @type {SymbolsManager} */
    this.symbolsManager = new SymbolsManager();

    /** @type {Object<string,Object<string,AbstractSymbol>>} */
    this._changingSymbols = {};

    /** @type {Array<MadnesTimer>} */
    this._changingTimers = [];
    /** @type {Object<string,MadnesObject>} */
    this._changingObjects = {};
    /** @type {Array<MadnesTween>} */
    this._changingTweens = [];

    /** @type {MadnesTween} */
    this._changingFadeIn;
    /** @type {MadnesTween} */
    this._changingFadeOut;
    /** @type {MadnesGroup} */
    this._changingGroup;


    /** @type {Object<string, AbstractSymbol>} */
    this._shufflingSymbols = {};
    /** @type {Array<MadnesTimer>} */
    this._shufflingTimers = [];

    /** @type {Array<ShuffleAnim>} */
    this._shufflingAnim = [];
    /** @type {MadnesObject} */
    this._mill;
    /** @type {MadnesTween} */
    this._millAnim;
    /** @type {MadnesTween} */
    this._shufflingFadeIn;
    /** @type {MadnesTween} */
    this._shufflingFadeOut;
    /** @type {MadnesGroup} */
    this._shufflingGroup;

    /** @type {AbstractSymbol} */
    this._rapearSpread;
    /** @type {Array<AbstractSymbol>} */
    this._rapearSymbols = [];
    /** @type {Array<MadnesObject>} */
    this._rapearObjects = [];


    /** @type {Array<MadnesTimer>} */
    this._rapearTimeouts = [];
    /** @type {MadnesTween} */
    this._rappearFadeIn;
    /** @type {MadnesTween} */
    this._rappearFadeOut;
    /** @type {MadnesGroup} */
    this._rappearGroup;

    /** @type {AbstractSymbol} */
    this._expandSpread;
    /** @type {Array<AbstractSymbol>} */
    this._expandSymbols = [];
    /** @type {Array<MadnesObject>} */
    this._expandObjects = [];
    /** @type {Array<MadnesTimer>} */
    this._expandTimeouts = [];

    /** @type {MadnesTween} */
    this._expandFadeIn;
    /** @type {MadnesTween} */
    this._expandFadeOut;
    /** @type {MadnesGroup} */
    this._expandGroup;

    /** @type {Array<AbstractSymbol>} */
    this._fsSymbols = [];
    /** @type {Array<MadnesTimer>} */
    this._fsTimers = [];

    /** @type {Array<AbstractSymbol>} */
    this._fsSymbolsBooks = [];
    /** @type {Array<AbstractSymbol>} */
    this._fsSymbolsBooksWin = [];
    this._fsOptions = [];
    /** @type {MadnesTween} */
    this._freespinsFadeIn;
    /** @type {MadnesTween} */
    this._freespinsFadeOut;
    /** @type {MadnesGroup} */
    this._freespinsGroup;


    this._timeouts = [];
};

/**
 * @param {GameAssets} gameAssets
 */
Preinfo.prototype.init = function(gameAssets) {
    this._assets = gameAssets;
};

Preinfo.prototype.setOnClose = function(func) {
    this._onClose = func;
};

Preinfo.prototype.create = function() {

    this._shuffling.initCirclePoints(640, 400, 140);
    this._shuffling.initPositions(340, 265, 150, 140);
    this._shuffling.setMinSteps(3);

    MI.controls.hideAllBtns();

    this._bg = MI.addImg(0, 0, "preinfo_bg");


    this._shufflingGroup = MI.addGroup().setAlpha(0);
    this._changingGroup = MI.addGroup().setAlpha(0);
    this._expandGroup = MI.addGroup().setAlpha(0);
    this._rappearGroup = MI.addGroup().setAlpha(0);
    this._freespinsGroup = MI.addGroup().setAlpha(0);


    var infotexts = madnes_get_json("infotext")["preinfo"];


    // this.preinfoExpand = MI.addImg(20 /* + 206 / 2*/, 50 /* + 60 / 2*/, "preinfo_atlas").setFrameName("expanding_wild");
    this.preinfoExpand = MI.addText(20,150, infotexts["expanding"]["content"], infotexts["style"]["normal"]);
    //this.preinfoExpand.setAnchor(0.5, 0.5);
    this.preinfoExpand.onInputDown(function() {
        this._stopBlinkTimers();
        this.stopAutorun();
        this.setExpand();
    }.bind(this));
    // this.preinfoExpandAct = MI.addImg(20, 50, "preinfo_atlas").setFrameName("expanding_wild_active");
    this.preinfoExpandAct = MI.addText(20,150, infotexts["expanding"]["content"], infotexts["style"]["active"]);
    this.preinfoExpandAct.setVisible(false);
    this.buttonsActive.push(this.preinfoExpandAct);
    this.buttons.push(this.preinfoExpand);
    this.preinfoExpandAct.setAnchor(0,0.5);
    this.preinfoExpand.setAnchor(0,0.5);


    this.preinfoRappear = MI.addText(20,250, infotexts["random"]["content"], infotexts["style"]["normal"])
        .onInputDown(function() {
            this._stopBlinkTimers();
            this.stopAutorun();
            this.setRappear();
        }.bind(this));
    this.preinfoRappearAct = MI.addText(20,250, infotexts["random"]["content"], infotexts["style"]["active"]).setVisible(false);
    this.buttonsActive.push(this.preinfoRappearAct);
    this.buttons.push(this.preinfoRappear);
    this.preinfoRappearAct.setAnchor(0,0.5);
    this.preinfoRappear.setAnchor(0,0.5);

    this.preinfoShuffling = MI.addText(20,350, infotexts["shuffling"]["content"], infotexts["style"]["normal"]).onInputDown(function() {
        this._stopBlinkTimers();
        this.stopAutorun();
        this.setShuffling();
    }.bind(this));
    this.preinfoShufflingAct = MI.addText(20,350, infotexts["shuffling"]["content"], infotexts["style"]["active"]).setVisible(false);
    this.buttonsActive.push(this.preinfoShufflingAct);
    this.buttons.push(this.preinfoShuffling);
    this.preinfoShufflingAct.setAnchor(0,0.5);
    this.preinfoShuffling.setAnchor(0,0.5);

    this.preinfoChanging = MI.addText(20,450, infotexts["changing"]["content"], infotexts["style"]["normal"]).onInputDown(function() {
        this._stopBlinkTimers();
        this.stopAutorun();
        this.setChanging();
    }.bind(this));
    this.preinfoChangingAct = MI.addText(20,450, infotexts["changing"]["content"], infotexts["style"]["active"]).setVisible(false);
    this.buttonsActive.push(this.preinfoChangingAct);
    this.buttons.push(this.preinfoChanging);
    this.preinfoChangingAct.setAnchor(0,0.5);
    this.preinfoChanging.setAnchor(0,0.5);

    this.preinfoFreeSpins = MI.addText(20,550, infotexts["featured"]["content"], infotexts["style"]["normal"]).onInputDown(function() {
        this._stopBlinkTimers();
        this.stopAutorun();
        this.setFreeSpins();
    }.bind(this));
    this.preinfoFreeSpinsAct = MI.addText(20,550, infotexts["featured"]["content"], infotexts["style"]["active"]).setVisible(false);
    this.buttonsActive.push(this.preinfoFreeSpinsAct);
    this.buttons.push(this.preinfoFreeSpins);
    this.preinfoFreeSpinsAct.setAnchor(0,0.5);
    this.preinfoFreeSpins.setAnchor(0,0.5);

    //this.setShuffling();
    //this.setChanging();
    //this.setRappear();
    //this.setExpand();
    //this.setFreeSpins();


    this._timeouts[0] = 3500;
    this._timeouts[1] = 3500;
    this._timeouts[2] = 5100;
    this._timeouts[3] = 5500;
    this._timeouts[4] = 5500;

    this._autorunIdx = 0;

    this._autorunFuncs[0] = function() { this.setExpand(true); }.bind(this);
    this._autorunFuncs[1] = function() { this.setRappear(true); }.bind(this);
    this._autorunFuncs[2] = function() { this.setShuffling(true); }.bind(this);
    this._autorunFuncs[3] = function() { this.setChanging(true); }.bind(this);
    this._autorunFuncs[4] = function() { this.setFreeSpins(true); }.bind(this);

    this.setExpand();
    this._autorunIdx++;

    this._autorunDelay = MI.createTimer().add(function() {
        this._autorun();
    }.bind(this), this._timeouts[0]);
};

Preinfo.prototype._autorun = function() {
    this._autorunInterval = MI.createTimer().add(this._autorun.bind(this), this._timeouts[this._autorunIdx]);

    this._autorunFuncs[this._autorunIdx]();
    this._autorunIdx++;

    if(this._autorunIdx >= this._autorunFuncs.length) {
        this._autorunIdx = 0;
    }
};

Preinfo.prototype._reinitButtons = function() {
    for(var i = 0; i < this.buttons.length; i++) {
        this.buttonsActive[i].setVisible(false);
        this.buttons[i].setVisible(true);
    }
};

/**
 * @param {MadnesObject} button
 * @param {MadnesObject} activeButton
 * @returns {undefined}
 */
Preinfo.prototype._blinkButton = function(button, activeButton) {
    var t;
    t = MI.createTimer().add(function() {
        activeButton && activeButton.setVisible(false);
        button && button.setVisible(true);
    }, 200);
    this._blinkTimers.push(t);

    t = MI.createTimer().add(function() {
        activeButton && activeButton.setVisible(true);
        button && button.setVisible(false);
    }, 400);

    this._blinkTimers.push(t);
};

/**
 * @param {boolean=} autoRun
 * @returns {undefined}
 */
Preinfo.prototype.setExpand = function(autoRun) {

    this._reinitButtons();

    this.preinfoExpandAct.setVisible(true);
    this.preinfoExpand.setVisible(false);

    var x = 340;
    var y = 265;

    autoRun && this._blinkButton(this.preinfoExpand, this.preinfoExpandAct);

    this._fadeOutActive().then(function() {

        this._clearAll();

        var symbols = [
            3,5,5,4,2,
            2,2,"symbol_Alchemist",3,2,
            0,1,4,5,8
        ];

        for(var j = 0; j < 3; j++) {
            for(var i = 0; i < 5; i++) {
                this._expandSymbols[this._expandSymbols.length] = this._createSymbol(x + 150 * i, y + 140 * j, symbols.shift());
            }
        }

        this._expandSpread = this._createSpreadSymbol(0, 0, false);
        var spreadWrapper = MI.addImg(x + 150 * 2, y + 140 * 1, null);
        spreadWrapper.addChild(this._expandSpread.getSprite());
        spreadWrapper.setAnchor(0.5, 0.5);
        spreadWrapper.setScale(this._scaleSymb, this._scaleSymb);

        //this._expandSymbols.push(this._expandSpread);
        //this._expandSymbols.push(spreadWrapper);

        this._expandObjects.push(spreadWrapper);

        for(var i = 0; i < this._expandSymbols.length; i++) {
            //console.log(this._expandSymbols[i]);
            this._expandGroup.add(this._expandSymbols[i].getSprite());
        }

        this._expandGroup.add(spreadWrapper);

        return this._fadeInExpand();

    }.bind(this)).then(function() {

        this._expandTimeouts[this._expandTimeouts.length] = MI.createTimer().add(function() {
            //raperSpread.setVisible(true);
            this._expandSpread.playSpreadAnim(500).then(function() {

                if(this._expandSymbols.length) {
                    this._expandSymbols[2].setVisible(false);
                    this._expandSymbols[7].setVisible(false);
                    this._expandSymbols[12].setVisible(false);
                }

            }.bind(this));
        }.bind(this), 600);

        this._expandTimeouts[this._expandTimeouts.length] = MI.createTimer().add(function() {

            for(var i = 5; i <= 7; i++) {

                var win = this._createWinSymbol(x + 150 * (i - 5), y + 140 * 1, 2);
                this._expandSymbols.push(win);
                this._expandGroup.add(win.getSprite());
                (function(win) {
                    win.playWinAnim().then(function() {
                        win.setVisible(false);
                    });
                } (win));
            }
        }.bind(this), 1100);

    }.bind(this));

    this._activeSlides["expand"] = true;
};

/**
 * @returns {Promise}
 */
Preinfo.prototype._fadeOutExpand = function() {

    return new Promise(function(res) {
        this._expandFadeOut = MI.addTween().to(this._expandGroup, { 'alpha': 0 }, {
            'duration': this._fadeOut,
            'callback': res
        });
    }.bind(this));
};

/**
 * @returns {Promise}
 */
Preinfo.prototype._fadeInExpand = function() {

    return new Promise(function(res) {
        this._expandFadeIn = MI.addTween().to(this._expandGroup, { 'alpha': 1 }, {
            'duration': this._fadeIn,
            'callback': res
        });
    }.bind(this));
};

Preinfo.prototype._clearExpand = function() {

    if(this._expandSpread) {
        this._expandSpread.stopSpreadAnim();
        this._expandSpread.destroy();
    }
    this._expandSpread = null;

    for(var i = 0; i < this._expandSymbols.length; i++) {
        this._expandSymbols[i].destroy();
    }
    this._expandSymbols = [];

    for(var i = 0; i < this._expandObjects; i++) {
        this._expandObjects[i].destroy();
    }
    this._expandObjects = [];

    for(var i = 0; i < this._expandTimeouts.length; i++) {
        this._expandTimeouts[i].stop();
    }
    this._expandTimeouts = [];
};

/**
 * @param {number} x
 * @param {number} y
 * @param {number|string} number
 * @returns {AbstractSymbol}
 */
Preinfo.prototype._createSymbol = function(x, y, number) {
    return this.symbolsManager.create(number, x, y, -1, -1).createSymbol()
        .setScale(this._scaleSymb, this._scaleSymb);
};

Preinfo.prototype._createSpreadSymbol = function(x, y, visible) {
    return this.symbolsManager.create("symbol_Alchemist", x, y, -1, -1).createSpreadSymbol("center", visible);
    //.setScale(this._scaleSymb, this._scaleSymb);
};

/**
 * @param {number} x
 * @param {number} y
 * @param {number|string} number
 * @returns {AbstractSymbol}
 */
Preinfo.prototype._createWinSymbol = function(x, y, number) {
    return this.symbolsManager.create(number, x, y, -1, -1).createWinSymbol()
        .setScale(this._scaleSymb, this._scaleSymb);
};

Preinfo.prototype._createFSSymbol = function(x, y) {
    return this.symbolsManager.create("symbol_Book", x, y, -1, -1).createFSAnim()
        .setScale(this._scaleSymb, this._scaleSymb);
};

/**
 * @param {boolean=} autoRun
 * @returns {undefined}
 */
Preinfo.prototype.setChanging = function(autoRun) {

    this._reinitButtons();

    this.preinfoChangingAct.setVisible(true);
    this.preinfoChanging.setVisible(false);

    autoRun && this._blinkButton(this.preinfoChanging, this.preinfoChangingAct);

    this._fadeOutActive().then(function() {
        this._clearAll();

        this._createChangingSymbol("00", 340, 265, "symbol_Q", "symbol_A");
        this._createChangingSymbol("10", 490, 265, "symbol_K", "symbol_A");
        this._createChangingSymbol("20", 640, 265, "symbol_J", "symbol_A");
        this._createChangingSymbol("30", 790, 265, "symbol_Q", "symbol_A");
        this._createChangingSymbol("40", 940, 265, "symbol_A", "symbol_A");

        this._createChangingSymbol("01", 340, 405, "symbol_A", "symbol_A");
        this._createChangingSymbol("11", 490, 405, "symbol_K", "symbol_A");
        this._createChangingSymbol("21", 640, 405, "symbol_K", "symbol_A");
        this._createChangingSymbol("31", 790, 405, "symbol_J", "symbol_A");
        this._createChangingSymbol("41", 940, 405, "symbol_Q", "symbol_A");

        this._createChangingSymbol("02", 340, 545, "symbol_Q", "symbol_A");
        this._createChangingSymbol("12", 490, 545, "symbol_J", "symbol_A");
        this._createChangingSymbol("22", 640, 545, "symbol_Q", "symbol_A");
        this._createChangingSymbol("32", 790, 545, "symbol_A", "symbol_A");
        this._createChangingSymbol("42", 940, 545, "symbol_J", "symbol_A");

        return this._fadeInChanging();

    }.bind(this)).then(function() {

        this._createChangingTimer(200, "00", "01", "02");
        this._createChangingTimer(500, "10", "11", "12");
        this._createChangingTimer(800, "20", "21", "22");
        this._createChangingTimer(1100, "30", "31", "32");
        this._createChangingTimer(1400, "40", "41", "42");

        return new Promise(function(res) {
            var t = MI.createTimer().add(res, 2000);
            this._changingTimers.push(t);
        }.bind(this));

    }.bind(this)).then(function() {

        var tw;

        var scaleY = 1.1;
        var shiftY = 190;

        for(var i = 1; i <= 5; i++) {
            this._changingObjects["mr" + i] = MI.addImg(MI.getWi() / 2 + 150 * (i - 3), shiftY, "multiplier_reel");

            this._changingObjects["mr" + i].setAnchor(0.5, 0).setBlend("ADD").setScale(2 * this._scaleSymb * 1, 2 * this._scaleSymb * scaleY);
            this._changingObjects["mr" + i].setAlpha(0);
            this._changingGroup.add(this._changingObjects["mr" + i]);

            tw = MI.addTween().to(this._changingObjects["mr" + i], { 'alpha': 1 }, {
                'delay': 300,
                'duration': 300
            });
            this._changingTweens.push(tw);
        }

        var multiInner = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 + 50, "multiplier_shine");
        multiInner.setAlpha(0).setAnchor(0.5, 0.5);
        multiInner.setTint(0xacf0ff);
        multiInner.setBlend("ADD").setScale(0.2 * 0.74 * this._scaleSymb, 0.2 * 0.74 * this._scaleSymb);
        this._changingGroup.add(multiInner);

        tw = MI.addTween().to(multiInner, { 'alpha': 1 }, { 'duration': 800 });
        this._changingTweens.push(tw);

        tw = MI.addTween().to(multiInner, { 'x': 0.74 * this._scaleSymb, 'y': 0.74 * this._scaleSymb }, { 'duration': 800, 'scale': true });
        this._changingTweens.push(tw);

        tw = MI.addTween().to(multiInner, { 'angle': 65 }, { 'duration': 4500 });
        this._changingTweens.push(tw);

        var multiOuter = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 + 50, "multiplier_shine");
        multiOuter.setAlpha(0).setAnchor(0.5, 0.5);
        multiOuter.setTint(0xacf0ff);
        multiOuter.setBlend("ADD").setScale(0.2 * this._scaleSymb, 0.2 * this._scaleSymb);
        this._changingGroup.add(multiOuter);

        tw = MI.addTween().to(multiOuter, { 'alpha': 1 }, { 'duration': 800 });
        this._changingTweens.push(tw);
        tw = MI.addTween().to(multiOuter, { 'x': 1 * this._scaleSymb, 'y': 1 * this._scaleSymb }, { 'duration': 800, 'scale': true });
        this._changingTweens.push(tw);
        tw = MI.addTween().to(multiOuter, { 'angle': -65 }, { 'duration': 4500 });
        this._changingTweens.push(tw);

        var multiText = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 + 50, "multi_big_atlas").setFrameName("5x_big")
            .setAlpha(0).setAnchor(0.5, 0.5).setScale(this._scaleSymb, this._scaleSymb);
        this._changingGroup.add(multiText);

        this._changingObjects["multiInner"] = multiInner;
        this._changingObjects["multiOuter"] = multiOuter;
        this._changingObjects["multiText"] = multiText;

        var t = MI.createTimer().add(function() {
            tw = MI.addTween().to(multiInner, { 'alpha': 0 }, {
                'delay': 300,
                'duration': 300
            });
            this._changingTweens.push(tw);

            tw = MI.addTween().to(multiOuter, { 'alpha': 0 }, {
                'delay': 300,
                'duration': 300
            });
            this._changingTweens.push(tw);

        }.bind(this), 2500);
        this._changingTimers.push(t);

        tw = MI.addTween().to(multiText, { 'alpha': 1 }, {
            'duration': 300,
            'delay': 400,
            'callback': function() {

                tw = MI.addTween().to(multiText, { 'x': 0.9 * this._scaleSymb, 'y': 0.9 * this._scaleSymb }, {
                    'scale': true,
                    'duration': 300,
                    'yoyo': true,
                    'count': 1,
                    'callback': function() {
                        tw = MI.addTween().to(multiText, { 'x': 0.9 * this._scaleSymb, 'y': 0.9 * this._scaleSymb }, {
                            'scale': true,
                            'duration': 250
                        });
                        this._changingTweens.push(tw);

                        tw = MI.addTween().to(multiText, { 'alpha': 0 }, {
                            'duration': 250,
                            'callback': function() {
                                this._changingObjects["multiText"] && multiText.setVisible(false);
                                this._changingObjects["multiInner"] && multiInner.setVisible(false);
                                this._changingObjects["multiOuter"] && multiOuter.setVisible(false);

                                for(var i = 1; i <= 5; i++) {
                                    tw = MI.addTween().to(this._changingObjects["mr" + i], { 'alpha': 0 }, {
                                        'duration': 200
                                    });
                                    this._changingTweens.push(tw);
                                }

                            }.bind(this)
                        });
                        this._changingTweens.push(tw);

                    }.bind(this)
                });
                this._changingTweens.push(tw);

            }.bind(this)
        });
        this._changingTweens.push(tw);

    }.bind(this));

    this._activeSlides["changing"] = true;
};

Preinfo.prototype._fadeInChanging = function() {
    return new Promise(function(res) {
        this._changingFadeIn = MI.addTween().to(this._changingGroup, { 'alpha': 1 }, {
            'duration': this._fadeIn,
            'callback': res
        });
    }.bind(this));
};

Preinfo.prototype._fadeOutChanging = function() {
    return new Promise(function(res) {
        this._changingFadeOut = MI.addTween().to(this._changingGroup, { 'alpha': 0 }, {
            'duration': this._fadeOut,
            'callback': res
        });
    }.bind(this));
};

Preinfo.prototype._createChangingSymbol = function(id, x, y, from, to) {
    this._changingSymbols[id] = {
        'symbol': this._createSymbol(x, y, from),
        'anim': this._createWinSymbol(x, y, to)
    };

    this._changingSymbols[id]['anim'].setVisible(false);

    this._changingGroup.add(this._changingSymbols[id]['symbol'].getSprite());
    this._changingGroup.add(this._changingSymbols[id]['anim'].getSprite());
};

Preinfo.prototype._createChangingTimer = function(delay, s1, s2, s3) {
    var t1 = MI.createTimer().add(function() {
        this._changeSymbol(s1);
        this._changeSymbol(s2);
        this._changeSymbol(s3);
    }.bind(this), delay);
    this._changingTimers.push(t1);
};

Preinfo.prototype._clearChanging = function() {

    for(var i = 0; i < this._changingTimers.length; i++) {
        this._changingTimers[i].stop();
    }
    this._changingTimers = [];

    for(var s in this._changingSymbols) {
        this._changingSymbols[s]['anim'].stopWinAnim();
        this._changingSymbols[s]['anim'].destroy();

        this._changingSymbols[s]['symbol'].destroy();
    }
    this._changingSymbols = {};

    for(var o in this._changingObjects) {
        this._changingObjects[o].destroy();
    }
    this._changingObjects = {};

    for(var i = 0; i < this._changingTweens.length; i++) {
        this._changingTweens[i].destroy();
    }
    this._changingTweens = [];
};

Preinfo.prototype._changeSymbol = function(s) {

    if(!this._changingSymbols[s]) {
        return;
    }

    var symbol = this._changingSymbols[s]['symbol'];
    var anim = this._changingSymbols[s]['anim'];

    var sData = this.symbolsManager.getSymbolData(symbol);

    this._changingSymbols[s]['symbol'].destroy();

    anim.setVisible(true);

    (function(anim) {
        anim.playWinAnim().then(function() {
            anim.setVisible(false);
            this._changingSymbols[s]['symbol'] = this._createSymbol(sData['px'], sData['py'], anim.getSymbolNum());
            this._changingGroup.add(this._changingSymbols[s]['symbol'].getSprite());
        }.bind(this));
    }.bind(this) (anim));

};

/**
 * @param {boolean=} autoRun
 * @returns {undefined}
 */
Preinfo.prototype.setShuffling = function(autoRun) {

    this._reinitButtons();

    this.preinfoShufflingAct.setVisible(true);
    this.preinfoShuffling.setVisible(false);

    autoRun && this._blinkButton(this.preinfoShuffling, this.preinfoShufflingAct);

    this._fadeOutActive().then(function() {

        this._clearAll();

        this._shufflingSymbols["00"] = this._createSymbol(340, 265, 7);
        this._shufflingSymbols["10"] = this._createSymbol(490, 265, 9);
        this._shufflingSymbols["20"] = this._createSymbol(640, 265, 7);
        this._shufflingSymbols["30"] = this._createSymbol(790, 265, 7);
        this._shufflingSymbols["40"] = this._createSymbol(940, 265, 2);

        this._shufflingSymbols["01"] = this._createSymbol(340, 405, 7);
        this._shufflingSymbols["11"] = this._createSymbol(490, 405, 9);
        this._shufflingSymbols["21"] = this._createSymbol(640, 405, 0);
        this._shufflingSymbols["31"] = this._createSymbol(790, 405, 2);
        this._shufflingSymbols["41"] = this._createSymbol(940, 405, 6);

        this._shufflingSymbols["02"] = this._createSymbol(340, 545, 0);
        this._shufflingSymbols["12"] = this._createSymbol(490, 545, 3);
        this._shufflingSymbols["22"] = this._createSymbol(640, 545, 0);
        this._shufflingSymbols["32"] = this._createSymbol(790, 545, 6);
        this._shufflingSymbols["42"] = this._createSymbol(940, 545, 6);

        for(var i in this._shufflingSymbols) {
            this._shufflingGroup.add(this._shufflingSymbols[i].getSprite());
        }

        return this._fadeInShuffling();

    }.bind(this)).then(function() {

        var proms = [];
        var p;

        p = this._createShuffleAnim("00", "21");
        proms.push(p);

        p = this._createShuffleAnim("10", "00");
        proms.push(p);

        p = this._createShuffleAnim("20", "31");
        proms.push(p);

        p = this._createShuffleAnim("30", "01");
        proms.push(p);

        p = this._createShuffleAnim("40", "20");
        proms.push(p);

        p = this._createShuffleAnim("01", "11");
        proms.push(p);

        p = this._createShuffleAnim("11", "10");
        proms.push(p);

        p = this._createShuffleAnim("21", "42");
        proms.push(p);

        p = this._createShuffleAnim("31", "30");
        proms.push(p);

        p = this._createShuffleAnim("41", "02");
        proms.push(p);

        p = this._createShuffleAnim("02", "32");
        proms.push(p);

        p = this._createShuffleAnim("12", "40");
        proms.push(p);

        p = this._createShuffleAnim("22", "41");
        proms.push(p);

        p = this._createShuffleAnim("32", "12");
        proms.push(p);

        p = this._createShuffleAnim("42", "22");
        proms.push(p);

        this._mill = this._assets.createMill(MI.getWi() / 2, MI.getHe() / 2 + 20, true);
        this._mill.setScale(0.6, 0.6);
        this._mill.setAlpha(0);
        this._shufflingGroup.add(this._mill);


        this._millAnim = MI.addTween().to(this._mill, { 'alpha': 1 }, {
            'duration': 500,
            'yoyo': true,
            'yoyoDelay': 2000,
            'callback': function() { this._mill.setVisible(false); }.bind(this)
        });
        this._assets.startSpinMill();
        this._assets.millSpeedUp(8, 800);

        return Promise.all(proms);

    }.bind(this)).then(function() {

        /*var symb = this._shufflingSymbols["10"];
        console.log(this._shufflingSymbols["10"]);
        this._createWinSymbol();*/

        var t = MI.createTimer().add(function() {

            this._playShuffleWinSymbol("10");
            this._playShuffleWinSymbol("11");

        }.bind(this), 100);

        this._shufflingTimers.push(t);

        t = MI.createTimer().add(function() {
            this._playShuffleWinSymbol("20");
            this._playShuffleWinSymbol("30");
            this._playShuffleWinSymbol("01");
            this._playShuffleWinSymbol("00");
        }.bind(this), 500);

        this._shufflingTimers.push(t);

        t = MI.createTimer().add(function() {
            this._playShuffleWinSymbol("41");
            this._playShuffleWinSymbol("32");
            this._playShuffleWinSymbol("42");
        }.bind(this), 1000);

        this._shufflingTimers.push(t);

    }.bind(this));

    this._activeSlides["shuffling"] = true;
};

/**
 *
 * @param {string} id
 * @returns {undefined}
 */
Preinfo.prototype._playShuffleWinSymbol = function(id) {
    var symb = this._createShuffleWinSymbol(id);
    symb.playWinAnim().then(function() {
        symb.destroy();
    });
};

/**
 * @param {string} id
 * @returns {AbstractSymbol}
 */
Preinfo.prototype._createShuffleWinSymbol = function(id) {
    var symb = this._shufflingSymbols[id];
    var winSym = this._createWinSymbol(symb.getPosX(), symb.getPosY(), symb.getSymbolNum());

    this._shufflingGroup.add(winSym.getSprite());
    this._shufflingSymbols[id + "a"] = winSym;

    return winSym;
};

Preinfo.prototype._fadeInShuffling = function() {
    return new Promise(function(res) {
        this._shufflingFadeIn = MI.addTween().to(this._shufflingGroup, { 'alpha': 1 }, {
            'duration': this._fadeIn,
            'callback': res
        });
    }.bind(this));
};

Preinfo.prototype._fadeOutShuffling = function() {

    return new Promise(function(res) {
        this._shufflingFadeOut = MI.addTween().to(this._shufflingGroup, { 'alpha': 0 }, {
            'duration': this._fadeOut,
            'callback': res
        });
    }.bind(this));
};

/**
 * @param {string} from
 * @param {string} to
 * @returns {Promise}
 */
Preinfo.prototype._createShuffleAnim = function(from, to) {
    var delay = 500;
    var s = this._shuffling.createShuffle(this.getShuffSymbol(from));
    this._shufflingAnim.push(s);
    return s.run(this._shuffling.getPath(from, to), delay, 600, 1000, 600);
};

Preinfo.prototype._clearShuffling = function() {

    for(var i = 0; i < this._shufflingAnim.length; i++) {
        this._shufflingAnim[i].stop();
    }
    this._shufflingAnim = [];

    for(var i = 0; i < this._shufflingTimers.length; i++) {
        this._shufflingTimers[i].stop();
    }
    this._shufflingTimers = [];

    for(var i in this._shufflingSymbols) {
        this._shufflingSymbols[i].destroy();
    }
    this._shufflingSymbols = {};

    this._assets.stopSpinMill();

    if(this._mill) {
        this._assets.destroyMill(this._mill);
    }
    this._mill && this._mill.destroy();

    if(this._millAnim) {
        this._millAnim.stop();
        this._millAnim.destroy();
    }

    this._millAnim = null;
};

/**
 * @param {string} id
 * @returns {MadnesObject}
 */
Preinfo.prototype.getShuffSymbol = function(id) {
    return this._shufflingSymbols[id].getSprite();
};

/**
 * @param {boolean=} autoRun
 * @returns {undefined}
 */
Preinfo.prototype.setRappear = function(autoRun) {

    this._reinitButtons();

    this.preinfoRappearAct.setVisible(true);
    this.preinfoRappear.setVisible(false);

    var x = 340;
    var y = 265;

    var symbols = [
        1,4,5,3,1,
        2,2,3,7,2,
        0,3,8,6,9
    ];

    /** @type {AbstractSymbol} */
    var rapearIn;
    /** @type {AbstractSymbol} */
    var rapearOut;

    autoRun && this._blinkButton(this.preinfoRappear, this.preinfoRappearAct);

    this._fadeOutActive().then(function() {

        this._clearAll();

        for(var j = 0; j < 3; j++) {
            for(var i = 0; i < 5; i++) {
                this._rapearSymbols[this._rapearSymbols.length] = this._createSymbol(x + 150 * i, y + 140 * j, symbols.shift());
            }
        }

        rapearOut = this._rapearSymbols[7];
        rapearIn = this._createSymbol(x + 150 * 2, y + 140 * 1, 10).setAlpha(0);
        this._rapearSymbols.push(rapearIn);

        this._rapearSpread = this._createSpreadSymbol(0, 0, false);
        var spreadWrapper = MI.addImg(x + 150 * 2, y + 140 * 1, null);
        spreadWrapper.addChild(this._rapearSpread.getSprite());
        spreadWrapper.setAnchor(0.5, 0.5);
        spreadWrapper.setScale(this._scaleSymb, this._scaleSymb);

        this._rapearObjects.push(spreadWrapper);

        for(var i = 0; i < this._rapearSymbols.length; i++) {
            this._rappearGroup.add(this._rapearSymbols[i].getSprite());
        }

        this._rappearGroup.add(spreadWrapper);

        return this._fadeInRappear();

    }.bind(this)).then(function() {

        this._rapearTimeouts[this._rapearTimeouts.length] = MI.createTimer().add(function() {
            MI.addTween().to(rapearOut.getSprite(), { 'alpha': 0 }, { 'duration': 500 });
            MI.addTween().to(rapearIn.getSprite(), { 'alpha': 1 }, { 'duration': 500 });
        }, 600);

        this._rapearTimeouts[this._rapearTimeouts.length] = MI.createTimer().add(function() {
            //raperSpread.setVisible(true);
            this._rapearSpread && this._rapearSpread.playSpreadAnim(500).then(function() {

                if(this._rapearSymbols.length) {
                    rapearIn.setVisible(false);
                    this._rapearSymbols[2].setVisible(false);
                    this._rapearSymbols[7].setVisible(false);
                    this._rapearSymbols[12].setVisible(false);
                }

            }.bind(this));
        }.bind(this), 1500);

        this._rapearTimeouts[this._rapearTimeouts.length] = MI.createTimer().add(function() {
            for(var i = 5; i <= 7; i++) {
                var win = this._createWinSymbol(x + 150 * (i - 5), y + 140 * 1, 2);
                this._rapearSymbols.push(win);
                this._rappearGroup.add(win.getSprite());
                (function(win) {
                    win.playWinAnim().then(function() {
                        win.setVisible(false);
                    });
                } (win));

            }
        }.bind(this), 2000);
    }.bind(this));

    this._activeSlides["rappear"] = true;
};

/**
 * @returns {Promise}
 */
Preinfo.prototype._fadeOutRappear = function() {
    return new Promise(function(res) {
        this._rappearFadeOut = MI.addTween().to(this._rappearGroup, { 'alpha': 0 }, {
            'duration': this._fadeOut,
            'callback': res
        });
    }.bind(this));
};

/**
 * @returns {Promise}
 */
Preinfo.prototype._fadeInRappear = function() {
    return new Promise(function(res) {
        this._rappearFadeIn = MI.addTween().to(this._rappearGroup, { 'alpha': 1 }, {
            'duration': this._fadeIn,
            'callback': res
        });
    }.bind(this));
};

Preinfo.prototype._clearRapear = function() {

    if(this._rapearSpread) {
        this._rapearSpread.stopSpreadAnim();
        this._rapearSpread.destroy();
    }
    this._rapearSpread = null;

    for(var i = 0; i < this._rapearSymbols.length; i++) {
        this._rapearSymbols[i].destroy();
    }
    this._rapearSymbols = [];

    for(var i = 0; i < this._rapearObjects.length; i++) {
        this._rapearObjects[i].destroy();
    }
    this._rapearObjects = [];

    for(var i = 0; i < this._rapearTimeouts.length; i++) {
        //console.log(this._rapearTimeouts[i]);
        this._rapearTimeouts[i].stop();
    }
    this._rapearTimeouts = [];
};

/**
 * @param {boolean=} autoRun
 * @returns {undefined}
 */
Preinfo.prototype.setFreeSpins = function(autoRun) {

    this._reinitButtons();

    this.preinfoFreeSpinsAct.setVisible(true);
    this.preinfoFreeSpins.setVisible(false);

    var x = 340;
    var y = 265;

    var symbols = [
        1,4,"symbol_Book",3,1,
        "symbol_Book",2,3,7,2,
        0,3,8,6,"symbol_Book"
    ];

    autoRun && this._blinkButton(this.preinfoFreeSpins, this.preinfoFreeSpinsAct);

    this._fadeOutActive().then(function() {

        this._clearAll();

        for(var j = 0; j < 3; j++) {
            for(var i = 0; i < 5; i++) {

                var symb = symbols.shift();
                if(symb === "symbol_Book") {

                    continue;

                } else {
                    var s = this._createSymbol(x + 150 * i, y + 140 * j, symb);
                    this._fsSymbols[this._fsSymbols.length] = s;
                    this._freespinsGroup.add(s.getSprite());
                }
            }
        }

        this._fsSymbolsBooks[0] = this._createSymbol(x + 150 * 0, y + 140 * 1, "symbol_Book");
        this._fsSymbolsBooks[0].createStandAnim();
        this._fsSymbolsBooks[0].setScale(this._scaleSymb, this._scaleSymb);
        this._fsSymbolsBooks[0].playStandAnim();

        this._fsSymbolsBooks[1] = this._createSymbol(x + 150 * 2, y + 140 * 0, "symbol_Book");
        this._fsSymbolsBooks[1].createStandAnim();
        this._fsSymbolsBooks[1].setScale(this._scaleSymb, this._scaleSymb);
        this._fsSymbolsBooks[1].playStandAnim();

        this._fsSymbolsBooks[2] = this._createSymbol(x + 150 * 4, y + 140 * 2, "symbol_Book");
        this._fsSymbolsBooks[2].createStandAnim();
        this._fsSymbolsBooks[2].setScale(this._scaleSymb, this._scaleSymb);
        this._fsSymbolsBooks[2].playStandAnim();

        for(var k = 0; k < this._fsSymbolsBooks.length; k++) {
            this._freespinsGroup.add(this._fsSymbolsBooks[k].getSprite());
        }

        this._fsSymbolsBooksWin[0] = this._createWinSymbol(x + 150 * 0, y + 140 * 1, "symbol_Book").setVisible(false);
        this._fsSymbolsBooksWin[1] = this._createWinSymbol(x + 150 * 2, y + 140 * 0, "symbol_Book").setVisible(false);
        this._fsSymbolsBooksWin[2] = this._createWinSymbol(x + 150 * 4, y + 140 * 2, "symbol_Book").setVisible(false);

        for(var k = 0; k < this._fsSymbolsBooksWin.length; k++) {
            this._freespinsGroup.add(this._fsSymbolsBooksWin[k].getSprite());
        }

        this._createPaper(5, this._fsSymbolsBooks[0].getPosX(), this._fsSymbolsBooks[0].getPosY());
        this._createPaper(9, this._fsSymbolsBooks[1].getPosX(), this._fsSymbolsBooks[1].getPosY());
        this._createPaper(7, this._fsSymbolsBooks[2].getPosX(), this._fsSymbolsBooks[2].getPosY());


        var scalePaper = function() {
            this._paperBgScale(); //this === FreeSpinOption
        };

        this._fsOptions[0].setFlyTo(MI.getWi() / 2 - 250, MI.getHe() / 2).onChoose(scalePaper);
        this._fsOptions[1].setFlyTo(MI.getWi() / 2 , MI.getHe() / 2).onChoose(scalePaper);
        this._fsOptions[2].setFlyTo(MI.getWi() / 2 + 250, MI.getHe() / 2).onChoose(scalePaper);

        return this._fadeInFreepins();

    }.bind(this)).then(function() {

        var t = MI.createTimer().add(function() {

            for(var i = 0; i < this._fsSymbolsBooksWin.length; i++) {

                (function(book, bookWin, i) {

                    bookWin.setVisible(true);
                    bookWin.playWinAnim().then(function() {
                        bookWin.destroy();
                        book.createFSAnim();
                        book.playFSAnim();
                    });

                    var t2 = MI.createTimer().add(function() {
                        this._fsOptions[i].play(0, 1, 2200);

                    }.bind(this), (i + 1) * 300);

                    this._fsTimers.push(t2);

                }.bind(this)(this._fsSymbolsBooks[i], this._fsSymbolsBooksWin[i], i));
            }
        }.bind(this), 500);
        this._fsTimers.push(t);

    }.bind(this));

    this._activeSlides["freespins"] = true;
};

Preinfo.prototype._createPaper = function(num, x, y) {

    var paper = new FreeSpinOption().create(x, y, num);
    paper.createPaper(num, true);
    paper._createBg();
    paper.setScaleTo(0.72);
    paper.button.setVisible(true);
    paper.enableButton();
    //paper.play(x + 50, he / 2);

    this._freespinsGroup.add(paper.getSprite());

    this._fsOptions.push(paper);
};

Preinfo.prototype._fadeInFreepins = function() {
    return new Promise(function(res) {
        this._freespinsFadeIn = MI.addTween().to(this._freespinsGroup, { 'alpha': 1 }, {
            'duration': this._fadeIn,
            'callback': res
        });
    }.bind(this));
};

Preinfo.prototype._fadeOutFreepins = function() {
    return new Promise(function(res) {
        this._freespinsFadeOut = MI.addTween().to(this._freespinsGroup, { 'alpha': 0 }, {
            'duration': this._fadeOut,
            'callback': res
        });
    }.bind(this));
};

Preinfo.prototype._clearFreeSpins = function() {

    for(var i = 0; i < this._fsOptions.length; i++) {
        this._fsOptions[i].destroy();
    }
    this._fsOptions = [];

    for(var i = 0; i < this._fsSymbols.length; i++) {
        this._fsSymbols[i].destroy();
    }
    this._fsSymbols = [];

    for(var i = 0; i < this._fsSymbolsBooks.length; i++) {
        this._fsSymbolsBooks[i].destroy();
        this._fsSymbolsBooksWin[i].destroy();
    }

    for(var i = 0; i < this._fsTimers.length; i++) {
        this._fsTimers[i] && this._fsTimers[i].stop();
    }

    this._fsTimers = [];

};

Preinfo.prototype.stopAutorun = function() {
    this._autorunInterval && this._autorunInterval.stop();
    this._autorunDelay && this._autorunDelay.stop();
};

Preinfo.prototype._stopAllFades = function() {
    this._freespinsFadeOut && this._freespinsFadeOut.stop();
    this._freespinsFadeIn && this._freespinsFadeIn.stop();
    this._expandFadeOut && this._expandFadeOut.stop();
    this._expandFadeIn && this._expandFadeIn.stop();
    this._rappearFadeOut && this._rappearFadeOut.stop();
    this._rappearFadeIn && this._rappearFadeIn.stop();
    this._changingFadeOut && this._changingFadeOut.stop();
    this._changingFadeIn && this._changingFadeIn.stop();
    this._shufflingFadeOut && this._shufflingFadeOut.stop();
    this._shufflingFadeIn && this._shufflingFadeIn.stop();
};

/**
 * @returns {Promise}
 */
Preinfo.prototype._fadeOutActive = function() {

    if(this._activeSlides["expand"]) {
        this._activeSlides["expand"] = false;
        return this._fadeOutExpand();
    }

    if(this._activeSlides["rappear"]) {
        this._activeSlides["rappear"] = false;
        return this._fadeOutRappear();
    }

    if(this._activeSlides["changing"]) {
        this._activeSlides["changing"] = false;
        //this._changingGroup.setAlpha(0);
        return this._fadeOutChanging();
    }

    if(this._activeSlides["shuffling"]) {
        this._activeSlides["shuffling"] = false;
        return this._fadeOutShuffling();
    }

    if(this._activeSlides["freespins"]) {
        this._activeSlides["freespins"] = false;
        return this._fadeOutFreepins();
    }

    return new Promise(function(res) { res(); });
};

Preinfo.prototype._clearAll = function() {
    this._clearChanging();
    this._clearShuffling();
    this._clearRapear();
    this._clearExpand();
    this._clearFreeSpins();
};

Preinfo.prototype.close = function() {
    this._clearAll();

    this.stopAutorun();

    this._stopBlinkTimers();

    for(var i = 0; i < this.buttons.length; i++) {
        this.buttons[i].destroy();
        this.buttonsActive[i].destroy();
    }

    MI.controls.showAllBtns();

    this._stopAllFades();

    this._changingGroup.destroy();
    this._shufflingGroup.destroy();
    this._rappearGroup.destroy();
    this._freespinsGroup.destroy();
    this._expandGroup.destroy();

    this._bg.destroy();
    this._onClose();
};

Preinfo.prototype._stopBlinkTimers = function() {
    for(var i = 0; i < this._blinkTimers.length; i++) {
        this._blinkTimers[i].stop();
    }
};